const alcoholDisplayOptions = [
  { value: '0', label: 'Select', exp: 'Select' },
  { value: '1', label: 'Less than 8 drinks a weekian' },
  { value: '2', label: 'Does not Cosume Alcohol'},
  { value: '3', label: 'More than 8 drinks a week'},
  { value: '4', label: 'Unknown'},
]

export default alcoholDisplayOptions
